import { __exports as PlusOrMinusPerUnit } from './_virtual-PlusOrMinusPerUnit.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import React from 'react';
import { __require as requirePricePresentation } from './vp-tokenized-fragment-build-PricePresentations-PricePresentation.js';

var hasRequiredPlusOrMinusPerUnit;

function requirePlusOrMinusPerUnit () {
	if (hasRequiredPlusOrMinusPerUnit) return PlusOrMinusPerUnit;
	hasRequiredPlusOrMinusPerUnit = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(PlusOrMinusPerUnit, "__esModule", {
	  value: true
	});
	PlusOrMinusPerUnit.default = void 0;
	var React$1 = _interopRequireWildcard(React);
	var _PricePresentation = _interopRequireDefault(requirePricePresentation());
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	let PlusOrMinusPerUnit$1 = class PlusOrMinusPerUnit extends React$1.Component {
	  render() {
	    return /*#__PURE__*/React$1.createElement(_PricePresentation.default, {
	      classNameWrapper: this.props.classNameWrapper,
	      type: "plusOrMinusPerUnit",
	      pricingInfo: this.props.pricingInfo,
	      placeHolderText: this.props.placeHolderText
	    });
	  }
	};
	PlusOrMinusPerUnit.default = PlusOrMinusPerUnit$1;
	
	return PlusOrMinusPerUnit;
}

export { requirePlusOrMinusPerUnit as __require };
//# sourceMappingURL=vp-tokenized-fragment-build-PricePresentations-components-PlusOrMinusPerUnit.js.map
